import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a15486a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "regulations" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 small-info" }, "Twoje dane będą bezpieczne.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-0 small-info" }, " Przestrzegamy zasad RODO i szanujemy twoją prywatność. ", -1))
const _hoisted_4 = { class: "small-info" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "future-link" }, "Regulamin serwisu", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "future-link" }, "Politykę prywatności", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", _hoisted_4, [
      _createTextVNode(" Logując się, akceptujesz "),
      _createElementVNode("a", {
        href: _ctx.getRegulations,
        target: "_blank",
        rel: "noopener noreferrer"
      }, _hoisted_7, 8, _hoisted_5),
      _createTextVNode(" i "),
      _createElementVNode("a", {
        href: _ctx.getPrivacyPolicy,
        target: "_blank",
        rel: "noopener noreferrer"
      }, [
        _hoisted_9,
        _createTextVNode(".")
      ], 8, _hoisted_8)
    ])
  ]))
}